# Generated by https://pagedraw.io/pages/5249
React = require 'react'


render = ->
    React.createElement("div", {"style": ({"display": "flex", "flexDirection": "column", "flexGrow": "1"})},
        React.createElement("style", {"dangerouslySetInnerHTML": (__html: """
            @import url('https://fonts.googleapis.com/css?family=Lato:');
            
            * {
                box-sizing: border-box;
            }
            
            body {
                margin: 0;
            }
            
            button:hover {
                cursor: pointer;
            }
            
            a {
                text-decoration: none;
                color: inherit;
            }
            
            .pd-onhover-parent >.pd-onhover {
                display: none;
            }
            
            .pd-onhover-parent:hover > * {
                display: none;
            }
            
            .pd-onhover-parent:hover > .pd-onhover {
                display: flex;
            }
            
            .pd-onactive-parent > .pd-onactive {
                display: none;
            }
            
            .pd-onactive-parent:active > * {
                display: none;
            }
            
            .pd-onactive-parent:active > .pd-onactive {
                display: flex;
            }
            
            .pd-onactive-parent.pd-onhover-parent:active > .pd-onhover {
                display: none;
            }
        """)}),  
        React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0"})},
            React.createElement("div", {"style": ({"display": "flex", "flexDirection": "column", "flexGrow": "1", "flexBasis": 0, "minHeight": "fit-content", "paddingTop": 20, "paddingBottom": 36, "borderRadius": 10, "boxShadow": "0px 5px 15px 0px rgba(0,0,0,0.07), 0px 15px 35px 0px rgba(50,50,93,0.10)", "background": "rgb(37, 37, 59)"})},
                React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0"})},
                    React.createElement("div", {"style": ({"height": 0, "flexGrow": "0.4977973568281938", "flexBasis": 0})}),  
                    React.createElement("div", {"style": ({"width": 121, "flexShrink": "0", "fontFamily": "\"Lato\", sans-serif", "color": "rgb(255, 255, 255)", "fontSize": 22, "lineHeight": "26px", "letterSpacing": 0, "fontWeight": "normal", "fontStyle": "normal", "textDecoration": "none", "textAlign": "center", "wordWrap": "break-word"})}, """
                        Company
"""),
                    React.createElement("div", {"style": ({"height": 0, "flexGrow": "0.5022026431718062", "flexBasis": 0})}) 
                ),
                React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0", "marginTop": 16})},
                    React.createElement("div", {"style": ({"height": 2, "flexGrow": "1", "flexBasis": 0, "background": "rgba(255, 255, 255, 0.2)"})}) 
                ),
                React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0", "marginTop": 33})},
                    React.createElement("div", {"style": ({"height": 0, "flexGrow": "0.4864864864864865", "flexBasis": 0})}),  
                    React.createElement("div", {"style": ({"display": "flex", "flexDirection": "column"})},
                        React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0", "paddingLeft": 27, "paddingRight": 27})},
                            React.createElement("div", {"style": ({"width": 257, "flexShrink": "0", "fontFamily": "\"Lato\", sans-serif", "color": "rgb(255, 255, 255)", "fontSize": 17, "lineHeight": "26px", "letterSpacing": 0, "fontWeight": "normal", "fontStyle": "normal", "textDecoration": "none", "textAlign": "center", "wordWrap": "break-word"})}, """
                                Pricing based on team size
""")
                        ),
                        React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0", "marginTop": 41, "paddingLeft": 124, "paddingRight": 125})},
                            React.createElement("div", {"style": ({"width": 62, "flexShrink": "0", "fontFamily": "\"Lato\", sans-serif", "color": "rgba(255, 255, 255, 0.6)", "fontSize": 12, "lineHeight": "normal", "letterSpacing": 0.46, "fontWeight": "normal", "fontStyle": "normal", "textDecoration": "none", "textAlign": "center", "wordWrap": "break-word"})}, """
                                INCLUDES
""")
                        ),
                        React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0", "marginTop": 12})},
                            React.createElement("div", {"style": ({"width": 311, "flexShrink": "0", "fontFamily": "\"Lato\", sans-serif", "color": "rgb(255, 255, 255)", "fontSize": 17, "lineHeight": "26px", "letterSpacing": 0, "fontWeight": "normal", "fontStyle": "normal", "textDecoration": "none", "textAlign": "center", "wordWrap": "break-word"})},
                                React.createElement("div", null, "Generated code supports older browsers"),
                                React.createElement("div", null, "Onboarding training"),
                                React.createElement("div", null, "Dedicated support"),
                                React.createElement("div", null, "Team collaboration features"),
                                React.createElement("div", null, "On-prem deployment"),
                                React.createElement("div", null, "Private Slack channel")
                            )
                        ),
                        React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0", "marginTop": 21, "paddingLeft": 77, "paddingRight": 77})},
                            React.createElement("a", {"href": "mailto:team@pagedraw.io", "style": ({"display": "flex"})},
                                React.createElement("div", {"style": ({"display": "flex", "flexDirection": "column", "borderRadius": 4, "boxShadow": "0px 5px 15px 0px rgba(0,0,0,0.07), 0px 15px 35px 0px rgba(50,50,93,0.10)", "background": "rgb(255, 255, 255)", "flexGrow": "1"})},
                                    React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0", "paddingLeft": 7, "paddingRight": 8})},
                                        React.createElement("div", {"style": ({"width": 142, "flexShrink": "0", "fontFamily": "\"Lato\", sans-serif", "color": "rgb(0, 0, 31)", "fontSize": 15, "lineHeight": "40px", "letterSpacing": 0.3308823, "fontWeight": "normal", "fontStyle": "normal", "textDecoration": "none", "textAlign": "center", "wordWrap": "break-word"})}, """
                                            Request a quote
""")
                                    )
                                )
                            )
                        )
                    ),
                    React.createElement("div", {"style": ({"height": 0, "flexGrow": "0.5135135135135135", "flexBasis": 0})}) 
                )
            )
        )
    )

module.exports = (props) -> render.apply({props})



// WEBPACK FOOTER //
// ./node_modules/cjsx-loader!./src/pagedraw/companycard.cjsx